import { z } from "zod"

export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 128

/** Small client-side denylist (server also checks a larger list + HIBP). */
const COMMON_PASSWORDS = new Set(
  [
    "12345678",
    "123456789",
    "1234567890",
    "123456789012",
    "password",
    "password1",
    "password12",
    "password123",
    "password1234",
    "qwerty123",
    "qwertyuiop",
    "admin123",
    "welcome123",
    "letmein",
    "iloveyou",
    "abc123456",
    "passw0rd!",
    "p@ssw0rd",
    "p@ssw0rd!",
    "changeme",
    "111111111111",
  ].map((p) => p.toLowerCase())
)

const HAS_LOWER = /[a-z]/
const HAS_UPPER = /[A-Z]/
const HAS_DIGIT = /\d/
const HAS_SYMBOL = /[^A-Za-z0-9]/

/**
 * Zod schema for new passwords (register, reset, admin create).
 * Mirrors API complexity rules; breach checks remain server-side.
 */
export const strongPasswordSchema = z
  .string()
  .min(
    PASSWORD_MIN_LENGTH,
    `Password must be at least ${PASSWORD_MIN_LENGTH} characters`
  )
  .max(
    PASSWORD_MAX_LENGTH,
    `Password must be at most ${PASSWORD_MAX_LENGTH} characters`
  )
  .refine((v) => HAS_LOWER.test(v), {
    message: "Password must include a lowercase letter",
  })
  .refine((v) => HAS_UPPER.test(v), {
    message: "Password must include an uppercase letter",
  })
  .refine((v) => HAS_DIGIT.test(v), {
    message: "Password must include a number",
  })
  .refine((v) => HAS_SYMBOL.test(v), {
    message: "Password must include a symbol",
  })
  .refine((v) => !COMMON_PASSWORDS.has(v.toLowerCase()), {
    message: "This password is too common. Please choose a different one.",
  })
